/**
 * Human-readable distance from today to a date, in Norwegian, at day
 * granularity: «I dag», «I morgen», «Om 6 dager», «Om 3 uker», «2 måneder
 * siden» … Shared by the convention and race lists. Returns null for a
 * missing or unparseable date.
 */
export default function formatRelativeDays(date) {
    if (!date) return null;
    const targetDay = new Date(date);
    if (Number.isNaN(targetDay.getTime())) return null;
    const startOfToday = new Date();
    startOfToday.setHours(0, 0, 0, 0);
    targetDay.setHours(0, 0, 0, 0);
    const diffDays = Math.round((targetDay.getTime() - startOfToday.getTime()) / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return 'I dag';
    if (diffDays === 1) return 'I morgen';
    if (diffDays === -1) return 'I går';
    if (diffDays > 1 && diffDays < 14) return `Om ${diffDays} dager`;
    if (diffDays >= 14 && diffDays < 60) return `Om ${Math.round(diffDays / 7)} uker`;
    if (diffDays >= 60 && diffDays < 365) return `Om ${Math.round(diffDays / 30)} måneder`;
    if (diffDays >= 365) return `Om ${Math.floor(diffDays / 365)} år`;
    if (diffDays < -1 && diffDays > -14) return `${Math.abs(diffDays)} dager siden`;
    if (diffDays <= -14 && diffDays > -60) return `${Math.round(Math.abs(diffDays) / 7)} uker siden`;
    if (diffDays <= -60 && diffDays > -365) return `${Math.round(Math.abs(diffDays) / 30)} måneder siden`;
    if (diffDays <= -365) return `${Math.floor(Math.abs(diffDays) / 365)} år siden`;
    return null;
}
